import React, { Component } from "react";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import { components } from "react-select";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import TabSection from "./TabSection";
import SelectDropDown from "../selectdropdown/SelectDropDown";
import DateBlock from "../home/DateBlock";
import { FeePageShimmer } from "../FeeStructure/FeeShimmer";

const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <i className="fal fa-angle-down" />
        </components.DropdownIndicator>
    );

const examTypes = [
    { value: 0, label: "All Exams" },
    { value: 1, label: "Mock Test" },
    { value: 2, label: "Custom Exam" },
    { value: 3, label: "Scheduled Exam" },
    { value: 4, label: "Error Exam" },
    { value: 6, label: "Practice Test" },
    { value: 7, label: "Adaptive Test" },
];

const ATRISK_QUERY = gql`
  query ($student_user_id: Int, $edu_student_id: Int, $exam_type: Int) {
    atRiskStudentPerformance(
      student_user_id: $student_user_id
      edu_student_id: $edu_student_id
      exam_type: $exam_type
    ) {
      student_user_id
      edu_student_id
      mobile
      riskScore
      riskLevel
      trend4wk
      attendance
      attendanceStatus
      lowestScoreExams {
        exam_name
        date
        percentage
      }
      triggersMet
      triggersTotal
      lastTestScores
      triggers {
        key
        title
        description
        status
        triggered
      }
      escalationPath {
        day
        title
        description
        owner
        channel
      }
      alerts
    }
  }
`;

const num = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
};

const resolveStudentId = (student) => {
    if (!student) return null;
    if (student.edu_student_id !== null && student.edu_student_id !== undefined) {
        return parseInt(student.edu_student_id);
    }
    if (student.student_user_id !== null && student.student_user_id !== undefined) {
        return parseInt(student.student_user_id);
    }
    // if (student.student_id !== null && student.student_id !== undefined) {
    //     return parseInt(student.student_id);
    // }
    return null;
};

// Risk level → accent color.
const riskLevelColor = (level) => {
    const l = `${level || ""}`.toLowerCase();
    if (l.includes("high")) return "#dc2626";
    if (l.includes("medium") || l.includes("moderate")) return "#d97706";
    if (l.includes("low")) return "#16a34a";
    return "#64748b";
};

const ESCALATION_COLORS = ["#6366f1", "#8b5cf6", "#f59e0b", "#ef4444", "#0ea5e9"];

class AtRiskTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedExamValue: { value: 0, label: "All Exams" },
            startDateCalender: moment(new Date()).subtract(1, "year").startOf("day").unix(),
            endDateCalender: moment(new Date()).endOf("day").unix(),
            data: null,
            loading: false,
        };
    }

    componentDidMount() {
        this.getReport(this.state.selectedExamValue?.value);
    }

    selecthandleInputChange = (name, value, selectedOption) => {
        this.setState({ [name]: selectedOption }, () => {
            this.getReport(selectedOption?.value);
        });
    };

    applyCallback = (startDate, endDate) => {
        const start = startDate.clone().startOf("day").unix();
        const end = endDate.clone().endOf("day").unix();
        this.setState({ startDateCalender: start, endDateCalender: end }, () => {
            this.getReport(this.state.selectedExamValue?.value);
        });
    };

    getReport = async (examType) => {
        const { student } = this.props;
        const examTypeFinal = examType ?? this.state.selectedExamValue?.value;
        this.setState({ loading: true });
        try {
            const result = await this.props.client.query({
                query: ATRISK_QUERY,
                variables: {
                    student_user_id: parseInt(student?.student_user_id) || 0,
                    edu_student_id: parseInt(student?.edu_student_id) || 0,
                    exam_type: examTypeFinal,
                },
                fetchPolicy: "network-only",
            });
            this.setState({ data: result?.data?.atRiskStudentPerformance || null, loading: false });
        } catch (error) {
            console.log(error);
            this.setState({ data: null, loading: false });
        }
    };

    // Exam + Date controls rendered at the end of the TabSection header.
    renderControls = () => (
        <div className="d-flex flex-wrap align-items-center justify-content-end" style={{ gap: "12px" }}>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                <span className="font-weight-bold text-muted" style={{ fontSize: "13px" }}>
                    Exam
                </span>
                <div style={{ minWidth: "170px" }}>
                    <SelectDropDown
                        stateData={this.state.selectedExamValue}
                        handleChange={this.selecthandleInputChange}
                        name="selectedExamValue"
                        options={examTypes}
                        placeholderName="Exam"
                        dropdownIndicator={{ DropdownIndicator }}
                    />
                </div>
            </div>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                <span className="font-weight-bold text-muted" style={{ fontSize: "13px" }}>
                    Date
                </span>
                <DateBlock
                    applyCallback={this.applyCallback}
                    start={moment.unix(this.state.startDateCalender)}
                    end={moment.unix(this.state.endDateCalender)}
                />
            </div>
        </div>
    );

    renderMetricCards = (d) => {
        const trend = num(d.trend4wk);
        const cards = [
            {
                label: "Risk Score",
                value: this.formatValue(d.riskScore),
                note: d.riskLevel || "-",
                noteColor: riskLevelColor(d.riskLevel),
                icon: "fa-heartbeat",
                iconBg: "linear-gradient(135deg, #f87171 0%, #dc2626 100%)",
            },
            {
                label: "4-wk Trend",
                value: `${trend > 0 ? "+" : ""}${this.formatValue(d.trend4wk)}`,
                note: "pts",
                noteColor: trend < 0 ? "#dc2626" : "#16a34a",
                icon: trend < 0 ? "fa-chart-line-down" : "fa-chart-line",
                iconBg: "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
            },
            {
                label: "Attendance",
                value: d.attendance != null ? `${num(d.attendance)}%` : "-",
                note: d.attendanceStatus || "-",
                noteColor: num(d.attendance) >= 75 ? "#16a34a" : "#dc2626",
                icon: "fa-calendar-alt",
                iconBg: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            },
            {
                label: "Triggers",
                value: `${this.formatValue(d.triggersMet)}/${this.formatValue(d.triggersTotal)}`,
                note: "criteria met",
                noteColor: num(d.triggersMet) > 0 ? "#dc2626" : "#16a34a",
                icon: "fa-flag",
                iconBg: "linear-gradient(135deg, #fb923c 0%, #f97316 100%)",
            },
        ];
        return (
            <Row className="mb-4">
                {cards.map((m) => (
                    <Col md={3} sm={6} key={m.label} className="mb-3 mb-md-0" style={{ minWidth: 0 }}>
                        <div
                            className="d-flex align-items-start justify-content-between p-3 h-100"
                            style={{
                                borderRadius: "16px",
                                background: "#ffffff",
                                border: "1px solid #f1f2f5",
                                boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                            }}
                        >
                            <div>
                                <span className="d-block text-muted" style={{ fontSize: "13px", fontWeight: 600 }}>
                                    {m.label}
                                </span>
                                <strong
                                    className="d-block text-dark"
                                    style={{ fontSize: "2rem", fontFamily: "'Outfit', sans-serif", lineHeight: 1.2 }}
                                >
                                    {m.value}
                                </strong>
                                <span className="font-weight-bold" style={{ fontSize: "12px", color: m.noteColor }}>
                                    {m.note}
                                </span>
                            </div>
                            <div
                                className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0"
                                style={{
                                    width: "44px",
                                    height: "44px",
                                    borderRadius: "12px",
                                    background: m.iconBg,
                                    boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
                                }}
                            >
                                <i className={`fas ${m.icon}`} style={{ fontSize: "18px" }}></i>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        );
    };

    // Left card — dropout/failure risk trigger criteria list.
    renderTriggers = (d) => {
        const triggers = d.triggers || [];
        return (
            <div
                className="p-4 h-100"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Dropout / Failure Risk — trigger criteria
                </h6>
                {triggers.map((t, i) => {
                    const fired = !!t.triggered;
                    const color = fired ? "#ef4444" : "#22c55e";
                    return (
                        <div
                            key={t.key ?? i}
                            className="d-flex align-items-start justify-content-between py-3"
                            style={{ gap: "12px", borderBottom: i < triggers.length - 1 ? "1px solid #f1f2f5" : "none" }}
                        >
                            <div className="d-flex align-items-start" style={{ gap: "12px", minWidth: 0 }}>
                                <span
                                    className="d-inline-block flex-shrink-0 mt-1"
                                    style={{ width: "10px", height: "10px", borderRadius: "50%", background: color }}
                                />
                                <div style={{ minWidth: 0 }}>
                                    <div className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                        {t.title || "-"}
                                    </div>
                                    {t.description ? (
                                        <div className="text-muted" style={{ fontSize: "12px" }}>
                                            {t.description}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <span
                                className="font-weight-bold flex-shrink-0"
                                style={{
                                    fontSize: "12px",
                                    padding: "4px 12px",
                                    borderRadius: "20px",
                                    background: fired ? "#fee2e2" : "#dcfce7",
                                    color,
                                }}
                            >
                                {fired ? "Triggered" : t.status || "Clear"}
                            </span>
                        </div>
                    );
                })}
                <div
                    className="d-flex align-items-center mt-3 p-3"
                    style={{ gap: "10px", borderRadius: "12px", background: "#fffbeb", border: "1px solid #fde68a" }}
                >
                    <i className="fas fa-exclamation-triangle" style={{ color: "#d97706", fontSize: "15px" }} />
                    <span className="text-dark" style={{ fontSize: "13px" }}>
                        <strong>{this.formatValue(d.triggersMet)} of {this.formatValue(d.triggersTotal)} triggers met</strong>
                        {num(d.triggersMet) > 0 ? " — auto-escalated; parents notified" : " — no action needed"}
                    </span>
                </div>
            </div>
        );
    };

    // Right card — escalation path timeline.
    renderEscalation = (d) => {
        const steps = d.escalationPath || [];
        return (
            <div
                className="p-4 h-100"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Escalation Path — 7-day timeline
                </h6>
                {steps.map((s, i) => (
                    <div
                        key={i}
                        className="d-flex py-2"
                        style={{ gap: "14px" }}
                    >
                        <div className="d-flex flex-column align-items-center flex-shrink-0">
                            <div
                                className="d-inline-flex align-items-center justify-content-center text-white font-weight-bold"
                                style={{
                                    width: "26px",
                                    height: "26px",
                                    borderRadius: "50%",
                                    fontSize: "12px",
                                    background: ESCALATION_COLORS[i % ESCALATION_COLORS.length],
                                }}
                            >
                                {i + 1}
                            </div>
                            {i < steps.length - 1 ? (
                                <span style={{ flex: 1, width: "2px", background: "#e2e8f0", marginTop: "2px" }} />
                            ) : null}
                        </div>
                        <div className="pb-3" style={{ minWidth: 0 }}>
                            <div className="font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                                {s.day != null ? `${s.day} · ` : ""}{s.title || "-"}
                            </div>
                            {s.description ? (
                                <div className="text-muted" style={{ fontSize: "12px" }}>
                                    {s.description}
                                </div>
                            ) : null}
                            {s.owner || s.channel ? (
                                <div className="text-muted mt-1" style={{ fontSize: "11px" }}>
                                    {s.channel ? s.channel : `Owner: ${s.owner}`}
                                </div>
                            ) : null}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Bottom card — instant alerts + action buttons.
    renderAlerts = (d) => {
        const alerts = d.alerts || [];
        const actionBtn = (label, icon, bg, color, border) => (
            <button
                type="button"
                key={label}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    border: border || "1px solid #e2e8f0",
                    background: bg || "#ffffff",
                    color: color || "#475569",
                    borderRadius: "10px",
                    padding: "8px 16px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                }}
            >
                <i className={`fas ${icon}`} style={{ fontSize: "13px" }} /> {label}
            </button>
        );
        return (
            <div
                className="p-4 mt-4"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Instant Alerts &amp; Parent Notification
                </h6>
                <Row className="align-items-end">
                    <Col lg={8}>
                        {alerts.length > 0 ? (
                            alerts.map((a, i) => (
                                <div
                                    key={i}
                                    className="d-flex align-items-center py-2"
                                    style={{ gap: "10px", borderBottom: i < alerts.length - 1 ? "1px solid #f1f2f5" : "none" }}
                                >
                                    <i className="fas fa-bell" style={{ color: "#6366f1", fontSize: "13px" }} />
                                    <span className="text-dark" style={{ fontSize: "13px" }}>{a}</span>
                                </div>
                            ))
                        ) : (
                            <div className="text-muted" style={{ fontSize: "13px" }}>No alerts configured.</div>
                        )}
                    </Col>
                    <Col lg={4}>
                        <div className="d-flex flex-wrap justify-content-lg-end mt-3 mt-lg-0" style={{ gap: "10px" }}>
                            {actionBtn("Alert Staff", "fa-bell")}
                            {actionBtn("Notify Parent", "fa-comment")}
                            {actionBtn(
                                "Escalate",
                                "fa-exclamation-triangle",
                                "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                                "#ffffff",
                                "none"
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    };

    // Lowest-scoring exams driving the risk score.
    renderLowestScores = (d) => {
        const rows = d.lowestScoreExams || [];
        const pctColor = (pct) => (pct < 60 ? "#dc2626" : pct < 80 ? "#d97706" : "#16a34a");
        return (
            <div
                className="p-4 mt-4"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Lowest Scoring Exams
                </h6>
                {rows.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-borderless mb-0" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr style={{ borderBottom: "1px solid #eef2f6" }}>
                                    <th className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase" }}>#</th>
                                    <th className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase" }}>Exam Name</th>
                                    <th className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase" }}>Date</th>
                                    <th className="text-muted text-center" style={{ fontSize: "11px", textTransform: "uppercase" }}>Percentage</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((e, i) => {
                                    const pct = num(e.percentage);
                                    return (
                                        <tr key={i} style={{ borderBottom: "1px solid #f6f8fb" }}>
                                            <td className="text-muted">{i + 1}</td>
                                            <td className="font-weight-bold text-dark">{this.formatValue(e.exam_name)}</td>
                                            <td className="text-muted">{this.formatValue(e.date)}</td>
                                            <td className="text-center font-weight-bold" style={{ color: pctColor(pct) }}>
                                                {e.percentage != null ? `${pct}%` : "-"}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No low-scoring exams.
                    </div>
                )}
            </div>
        );
    };

    formatValue = (v) => (v === null || v === undefined || v === "" ? "-" : v);

    render() {
        const { data, loading } = this.state;

        return (
            <TabSection
                icon="fa-exclamation-triangle"
                title="At-Risk"
                description="Early-warning indicators flagging students who need intervention."
                headerRight={this.renderControls()}
            >
                {loading ? (
                    <FeePageShimmer />
                ) : !data ? (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No at-risk data available.
                    </div>
                ) : (
                    <>
                        {this.renderMetricCards(data)}
                        <Row>
                            <Col lg={6} className="mb-4 mb-lg-0" style={{ minWidth: 0 }}>
                                {this.renderTriggers(data)}
                            </Col>
                            <Col lg={6} style={{ minWidth: 0 }}>
                                {this.renderEscalation(data)}
                            </Col>
                        </Row>
                        {this.renderLowestScores(data)}
                        {this.renderAlerts(data)}
                    </>
                )}
            </TabSection>
        );
    }
}

export default compose(withApollo, withRouter)(AtRiskTab);
